<template>
    <div class="grid-manage-right" v-if="formLabelAlign.name">
        <div class="grid-info">
            <el-form ref="form" label-position="top" label-width="80px" :model="formLabelAlign">
                <el-form-item :label="$t('gridManage.gridCode')">
                    <el-input v-model="formLabelAlign.gridCode"></el-input>
                </el-form-item>
                <el-form-item :label="$t('gridManage.gridName')">
                    <el-input v-model="formLabelAlign.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('gridManage.gridMaxAltitude')">
                    <el-input v-model="formLabelAlign.altitude"></el-input>
                </el-form-item>
                <el-form-item :label="$t('gridManage.gridStatus')">
                    <el-select style="width: 100%" v-model="formLabelAlign.executeStatus" placeholder="">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('gridManage.community')">
                    <el-select style="width: 100%" v-model="formLabelAlign.communityId" placeholder="">
                        <el-option
                            v-for="item in communitys"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('gridManage.gridArea')">
                    <el-input disabled v-model="gridArea"></el-input>
                </el-form-item>
                <el-form-item :label="$t('gridManage.gridLatLng')">
                    <el-input v-model="formLabelAlign.regions"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveForm">{{ $t('common.btnSave') }}</el-button>
                    <el-button @click="closeForm">{{ $t('common.btnClose') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import api from '../api.js';

export default {
    props: ['curGridInfo', 'getGridList', 'searchParams', 'gridList'],
    data() {
        return {
            gridArea: 1, // 面积写死
            formLabelAlign: {},
            // showForm: false,
            communitys: [],
        };
    },
    computed: {
        options() {
            return [
                {
                    value: 0,
                    label: this.$t('gridManage.flyable'),
                },
                {
                    value: 1,
                    label: this.$t('gridManage.noFly'),
                },
                {
                    value: 2,
                    label: this.$t('gridManage.disabled'),
                },
            ];
        },
    },
    mounted() {
        this.getCommunity();
    },
    watch: {
        curGridInfo: {
            deep: true,
            immediate: true,
            async handler(val) {
                let {
                    id,
                    name,
                    altitude,
                    coordinates,
                    defaultSiteId,
                    gridCode,
                    executeStatus,
                    regions,
                    communityId,
                } = val;
                this.formLabelAlign = {
                    id,
                    name,
                    altitude,
                    coordinates,
                    defaultSiteId,
                    gridCode,
                    executeStatus,
                    regions,
                    communityId,
                };
                if (communityId) return;
                // 获取社区
                let center = regions.split(';').map((item) => item.split(','));
                center.splice(-1);
                let res = this.getPointsCenter(center);
                this.formLabelAlign.communityId = await this.getAreaByLongitudeAndLatitude(
                    res.longitude,
                    res.latitude,
                );
            },
        },
    },

    methods: {
        async getCommunity() {
            let res = await api.getCommunity().run();
            this.communitys = [
                {
                    label: this.$t('gridManage.emptyOption'),
                    value: null,
                },
                ...res[0].children,
            ];
        },
        // 根据经纬度查询所属区域
        async getAreaByLongitudeAndLatitude(longitude, latitude) {
            let res = await api.getAreaByLongitudeAndLatitude({ longitude, latitude }).run();
            return (res && res.name) || this.$t('common.selectPlaceholder');
        },
        // 获取中心点
        getPointsCenter(points) {
            let pointNum = points.length; // 坐标点个数
            let X = 0;
            let Y = 0;
            let Z = 0;
            for (let i = 0; i < points.length; i++) {
                let lat;
                let lng;
                let x;
                let y;
                let z;
                lat = (parseFloat(points[i][1]) * Math.PI) / 180;
                lng = (parseFloat(points[i][0]) * Math.PI) / 180;
                x = Math.cos(lat) * Math.cos(lng);
                y = Math.cos(lat) * Math.sin(lng);
                z = Math.sin(lat);
                X += x;
                Y += y;
                Z += z;
            }
            X /= pointNum;
            Y /= pointNum;
            Z /= pointNum;
            let tmpLng = Math.atan2(Y, X);
            let tmpLat = Math.atan2(Z, Math.sqrt(X * X + Y * Y));
            return { latitude: (tmpLat * 180) / Math.PI, longitude: (tmpLng * 180) / Math.PI };
        },
        async saveForm() {
            await api.emitGrid(this.formLabelAlign).run();
            await this.getGridList(this.searchParams);
            this.$message.success(this.$t('gridManage.saveSuccess'));
            this.closeForm();
        },
        closeForm() {
            this.formLabelAlign = { ...this.curGridInfo };
            this.$emit('closeFormFn');
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
    padding-bottom: 0;
}
.grid-manage-right {
    width: 320px;
    height: 100%;
    padding: 10px;
    transition: all 0.2s;
    box-sizing: border-box;
    .grid-info {
        margin-top: 10px;
    }
}
</style>
